import { Controller } from "@hotwired/stimulus";

// Sets message_set folder_path from clickable folder rows (path picker UI).
export default class extends Controller {
  static targets = ["input", "summary"];

  connect() {
    this.syncSummaryFromInput();
  }

  pick(event) {
    event.preventDefault();
    event.stopPropagation();
    const btn = event.currentTarget;
    const path = btn.getAttribute("data-folder-path") || "";
    this.inputTarget.value = path;
    this.syncSummary(path);
    this.closeDropdown();
  }

  clearToUncategorized(event) {
    event.preventDefault();
    this.inputTarget.value = "";
    this.syncSummary("");
    this.closeDropdown();
  }

  syncSummaryFromInput() {
    if (!this.hasInputTarget) return;
    this.syncSummary(this.inputTarget.value.trim());
  }

  syncSummary(path) {
    if (!this.hasSummaryTarget) return;
    this.summaryTarget.textContent = path.length > 0 ? path : "Uncategorized";
  }

  closeDropdown() {
    const details = this.element.querySelector("details.folder-path-picker-dropdown");
    if (details) details.open = false;
  }
}
